import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { NavController } from '@ionic/angular';
import { AuthService } from '../services/auth.service';

export const refreshTokenInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const navCtrl = inject(NavController);
  const authService = inject(AuthService);
  
  return next(request).pipe(
    catchError(({ error: { errors } }) => {
      if (errors[0].extensions.code === 'UNAUTHORIZED') {
        return authService.refreshToken({ refreshToken: AuthService.refreshToken }).pipe(
          catchError(() => {
            authService.logout();

            navCtrl.navigateRoot('/');
            return throwError(() => errors[0]);
          }),
          switchMap(({ data }) => {
            const { accessToken, refreshToken } = data!.authMsRefreshAccessToken;

            AuthService.authToken = accessToken!;
            AuthService.refreshToken = refreshToken!;

            if (localStorage) {
              localStorage.setItem('authToken', accessToken!);
              localStorage.setItem('refreshToken', refreshToken!);
            }

            return next(request.clone({
              setHeaders: {
                authorization: accessToken!
              }
            }));
          }),
        );
      }
      return throwError(() => errors[0]);
    })
  );
};
